import { initSharedStorage } from 'common/libs/sharedStorage';
import { lazy, Suspense, useEffect, useState } from 'react';
const App = lazy(() => import('./App').then(module => ({
    default: module.App,
})));
export function DependencyContainer() {
    const [dependenciesInitialized, setDependenciesInitialized] = useState(false);
    useEffect(() => {
        initSharedStorage().finally(() => setDependenciesInitialized(true));
    }, []);
    if (!dependenciesInitialized) {
        return null;
    }
    return (<Suspense fallback={null}>
      <App />
    </Suspense>);
}
